document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.mosaic__item__inner');

    elements.forEach(element => {
        element.addEventListener('click', () => {
            const href = element.getAttribute('data-href');
            if (href) {
                window.location.href = href;
            }
        });

        element.style.cursor = 'pointer';
    });
});
